import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollTaxDetailItemDTO  {
    _originalTypeClassName = "zERP.BO.PayrollTaxDetailItemDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollTaxDetailItemDTO.translate = translateService;
}
this.Id = null;
this.Tax = null;
this.PayrollTaxDetailItemDTOKey = null;
this._key = this.PayrollTaxDetailItemDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Id:any;
Tax:any;
SalaryDTO:any;
private _PayrollTaxDetailItemDTOKey:any;
get PayrollTaxDetailItemDTOKey(): any {
    return this._PayrollTaxDetailItemDTOKey;
  }
set PayrollTaxDetailItemDTOKey(value: any) {
    this._PayrollTaxDetailItemDTOKey = value;
    this._key = value;
  }
static setSalaryDTO = ($this, value) => {
var oldValue = $this.SalaryDTO;
$this.SalaryDTO = value;
if (value != null) {
}
}

static Assign(ptdi: any): any{let ptdiDTO = new Domain.PayrollTaxDetailItemDTO();
ptdiDTO.Id = ptdi?.Id;
ptdiDTO.Tax = ptdi?.Tax;
Domain.PayrollTaxDetailItemDTO.setSalaryDTO(ptdiDTO, Domain.PayrollSalaryDetailDTO.Assign(ptdi?.Salary));
return ptdiDTO;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PayrollTaxDetailItemDTOKey == null || $this.PayrollTaxDetailItemDTOKey == 0;
            }


}